<template>
  <div class="car-sell-offer">
    <div class="car-sell-offer__container">
      <!-- 左侧内容区域 -->
      <div class="car-sell-offer__info">
        <div class="car-sell-offer__title" v-html="domainConfig.gallery.title"></div>
        <div class="car-sell-offer__desc" v-html="domainConfig.gallery.content"></div>
        <div class="car-sell-offer__button" @click="gotoAll">
          <div class="car-sell-offer__button-text">Get Started</div>
        </div>
      </div>

      <!-- 右侧图片区域 -->
      <div class="car-sell-offer__gallery">
        <img :src="domainConfig.galleryImages" class="car-sell-offer__gallery-img" alt="sell car">
      </div>
    </div>

    <!-- 功能特点区域 -->
    <div class="car-sell-offer__features">
      <div class="car-sell-offer__feature">
        <div class="car-sell-offer__icon-wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"
            fill="none" class="car-sell-offer__feature-icon">
            <path
              d="M18 0C8.0589 0 0 8.0589 0 18C0 27.9411 8.0589 36 18 36C27.9411 36 36 27.9411 36 18C35.9888 8.06355 27.9365 0.01125 18 0ZM34.1496 22.6164L33.0222 22.2498L32.6508 23.3898L33.783 23.7576C33.3147 25.0349 32.693 26.2507 31.9314 27.378L30.9714 26.682L30.2658 27.6528L31.2186 28.3452C30.3801 29.4155 29.416 30.3809 28.347 31.221L27.6546 30.2682L26.6838 30.9738L27.3798 31.9338C26.2526 32.6945 25.037 33.3155 23.76 33.783L23.3922 32.6508L22.2522 33.0222L22.6188 34.1496C21.3101 34.5243 19.9605 34.7377 18.6 34.785V33.6H17.4V34.785C16.0403 34.7375 14.6915 34.5242 13.3836 34.1496L13.7502 33.0222L12.6102 32.6508L12.24 33.783C10.9627 33.3147 9.74693 32.693 8.6196 31.9314L9.3156 30.9714L8.3448 30.2658L7.6524 31.2186C6.58267 30.3793 5.61773 29.4143 4.7784 28.3446L5.7312 27.6522L5.0256 26.6814L4.0656 27.3774C3.3063 26.2507 2.68658 25.0361 2.22 23.76L3.3522 23.3922L2.9808 22.2522L1.8534 22.6188C1.47765 21.3102 1.2633 19.9606 1.215 18.6H2.4V17.4H1.215C1.26248 16.0403 1.47585 14.6915 1.8504 13.3836L2.9778 13.7502L3.3492 12.6102L2.22 12.24C2.6883 10.9627 3.31005 9.74693 4.0716 8.6196L5.0316 9.3156L5.7372 8.3448L4.779 7.653C5.61833 6.58328 6.58328 5.61833 7.653 4.779L8.3454 5.7318L9.3162 5.0262L8.6202 4.0662C9.7476 3.30653 10.9631 2.68658 12.24 2.22L12.6078 3.3522L13.7478 2.9808L13.3812 1.8534C14.6898 1.47765 16.0394 1.2633 17.4 1.215V2.4H18.6V1.215C19.9597 1.26248 21.3085 1.47585 22.6164 1.8504L22.2498 2.9778L23.3898 3.3492L23.76 2.22C25.0373 2.6883 26.2531 3.31005 27.3804 4.0716L26.6844 5.0316L27.6552 5.7372L28.3476 4.7844C29.4173 5.62373 30.3823 6.58868 31.2216 7.6584L30.2688 8.3508L30.9744 9.3216L31.9344 8.6256C32.6945 9.7512 33.3152 10.9649 33.783 12.24L32.6508 12.6078L33.0222 13.7478L34.1496 13.3812C34.5243 14.6899 34.7377 16.0395 34.785 17.4H33.6V18.6H34.785C34.7375 19.9597 34.5242 21.3085 34.1496 22.6164Z" />
            <path
              d="M18 4.8C10.7099 4.8 4.8 10.7099 4.8 18C4.8 25.2902 10.7099 31.2 18 31.2C25.2902 31.2 31.2 25.2902 31.2 18C31.1918 10.7133 25.2867 4.80825 18 4.8ZM18 30C11.3726 30 6 24.6275 6 18C6 11.3726 11.3726 6 18 6C24.6275 6 30 11.3726 30 18C29.9924 24.6242 24.6243 29.9924 18 30Z" />
            <path
              d="M18 7.8C12.3667 7.8 7.8 12.3667 7.8 18C7.8 23.6333 12.3667 28.2 18 28.2C23.6333 28.2 28.2 23.6333 28.2 18C28.1937 12.3693 23.6307 7.8063 18 7.8ZM25.7154 13.3902C26.413 14.5482 26.8383 15.8495 26.9592 17.196L23.2014 16.8924C22.8712 16.8647 22.626 16.5744 22.6538 16.2443C22.667 16.0877 22.7411 15.9426 22.86 15.84L25.7154 13.3902ZM20.0034 9.2328L18.5538 12.7128C18.4263 13.0187 18.075 13.1632 17.7691 13.0358C17.6231 12.9749 17.5071 12.8588 17.4462 12.7128L15.9966 9.2328C17.3142 8.92237 18.6858 8.92237 20.0034 9.2328ZM10.2846 13.39L13.14 15.84C13.3916 16.0556 13.4207 16.4345 13.2051 16.686C13.1021 16.8062 12.9558 16.8808 12.798 16.8936L9.0402 17.1972C9.1611 15.8502 9.58665 14.5484 10.2846 13.39ZM15.3372 22.6044L14.466 26.2752C13.2247 25.7393 12.1194 24.932 11.2314 23.9124H11.2296L14.4408 21.9534C14.7236 21.7807 15.0929 21.8699 15.2656 22.1528C15.3482 22.288 15.3739 22.4503 15.3372 22.6044ZM21.534 26.2752H21.5322L20.6592 22.6044C20.5825 22.2821 20.7816 21.9585 21.104 21.8818C21.2581 21.8451 21.4204 21.8708 21.5556 21.9534L24.7668 23.9124C23.8793 24.9317 22.7747 25.7391 21.534 26.2752ZM22.182 20.9286C21.3334 20.4108 20.2257 20.6789 19.7079 21.5275C19.4605 21.9331 19.3833 22.4201 19.4934 22.8822L20.3934 26.667C18.8283 27.111 17.1705 27.111 15.6054 26.667H15.6042L16.5042 22.8822C16.7341 21.9151 16.1366 20.9446 15.1694 20.7146C14.7074 20.6048 14.2209 20.6819 13.8156 20.9292L10.4952 22.956C9.59865 21.6001 9.0888 20.0255 9.0204 18.4014L12.8952 18.0882C13.886 18.007 14.6233 17.1379 14.5421 16.1471C14.5033 15.6747 14.2798 15.2366 13.92 14.928L10.968 12.396C11.9824 11.1269 13.3204 10.1549 14.841 9.5826L16.3362 13.1724C16.7183 14.0901 17.7721 14.5244 18.6898 14.1421C19.1285 13.9595 19.477 13.6109 19.6596 13.1724L21.1554 9.5826C22.6759 10.1551 24.0139 11.127 25.0284 12.396L22.08 14.928C21.3255 15.5753 21.2386 16.7117 21.886 17.4662C22.195 17.8263 22.6337 18.0498 23.1066 18.0882L26.9814 18.4014C26.913 20.0255 26.4032 21.6001 25.5066 22.956L22.182 20.9286Z" />
            <path
              d="M18 15.6C16.6745 15.6 15.6 16.6745 15.6 18C15.6 19.3255 16.6745 20.4 18 20.4C19.3255 20.4 20.4 19.3255 20.4 18C20.4 16.6745 19.3255 15.6 18 15.6ZM18 19.2C17.3372 19.2 16.8 18.6628 16.8 18C16.8 17.3372 17.3372 16.8 18 16.8C18.6628 16.8 19.2 17.3372 19.2 18C19.2 18.6628 18.6628 19.2 18 19.2Z" />
          </svg>
        </div>
        <div class="car-sell-offer__feature-title">Categorized Viewing</div>
        <div class="car-sell-offer__feature-desc">Browse by brand, model, and price.</div>
      </div>

      <div class="car-sell-offer__feature">
        <div class="car-sell-offer__icon-wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" class="car-sell-offer__feature-icon" width="36"
            height="36" viewBox="0 0 36 36" fill="none">
            <path
              d="M7.8 20.4H7.2V0.6C7.2 0.26865 6.93135 0 6.6 0H4.2C3.86865 0 3.6 0.26865 3.6 0.6V20.4H3C1.344 20.402 0.00195 21.744 0 23.4V33C0.00195 34.656 1.344 35.9981 3 36H7.8C9.456 35.9981 10.7981 34.656 10.8 33V23.4C10.7981 21.744 9.456 20.402 7.8 20.4ZM4.8 1.2H6V20.4H4.8V1.2ZM9.6 33C9.6 33.9941 8.79413 34.8 7.8 34.8H3C2.00588 34.8 1.2 33.9941 1.2 33V23.4C1.2 22.4059 2.00588 21.6 3 21.6H7.8C8.79413 21.6 9.6 22.4059 9.6 23.4V33Z" />
            <path
              d="M21.0392 20.4104C20.9567 20.4035 20.8739 20.4 20.7912 20.4H19.5708L17.4 16.0584V0.6C17.4 0.26865 17.1314 0 16.8 0H14.4C14.0687 0 13.8 0.26865 13.8 0.6V16.2C13.7999 16.2931 13.8215 16.3849 13.863 16.4682L15.8292 20.4H15.2088C14.3699 20.4008 13.5695 20.7518 13.0008 21.3684C12.4343 21.9865 12.1517 22.8129 12.2208 23.6484L13.0206 33.2484C13.158 34.799 14.4521 35.9906 16.0086 36H19.9914C21.548 35.9909 22.8423 34.7995 22.98 33.249L23.7798 23.649C23.9174 21.9979 22.6903 20.5479 21.0392 20.4104ZM15 16.0584V1.2H16.2V16.2C16.1999 16.2931 16.2215 16.3849 16.263 16.4682L18.2292 20.4H17.1708L15 16.0584ZM22.5858 23.5494L21.786 33.1494C21.7031 34.0801 20.9258 34.7951 19.9914 34.8H16.0086C15.0743 34.7951 14.297 34.0801 14.214 33.1494L13.4142 23.5494C13.3317 22.5587 14.0679 21.6887 15.0586 21.6062C15.1085 21.6021 15.1586 21.6 15.2088 21.6H20.7888C21.2936 21.5969 21.776 21.8083 22.116 22.1814C22.4591 22.5504 22.6298 23.0475 22.5858 23.5494Z" />
            <path
              d="M34.2 6.2544V0.6C34.2 0.26865 33.9314 0 33.6 0H28.2C27.8687 0 27.6 0.26865 27.6 0.6V6.2544C26.508 6.73095 25.8016 7.80855 25.8 9V33C25.802 34.656 27.144 35.9981 28.8 36H33C34.656 35.9981 35.9981 34.656 36 33V9C35.9984 7.80855 35.292 6.73095 34.2 6.2544ZM28.8 1.2H33V6H28.8V1.2ZM34.8 33C34.8 33.9941 33.9941 34.8 33 34.8H28.8C27.8059 34.8 27 33.9941 27 33V9C27 8.00588 27.8059 7.2 28.8 7.2H33C33.9941 7.2 34.8 8.00588 34.8 9V33Z" />
            <path
              d="M7.8 22.8H3C2.66865 22.8 2.4 23.0687 2.4 23.4C2.4 23.7314 2.66865 24 3 24H7.8C8.13135 24 8.4 23.7314 8.4 23.4C8.4 23.0687 8.13135 22.8 7.8 22.8Z" />
            <path
              d="M7.8 25.2H3C2.66865 25.2 2.4 25.4687 2.4 25.8C2.4 26.1314 2.66865 26.4 3 26.4H7.8C8.13135 26.4 8.4 26.1314 8.4 25.8C8.4 25.4687 8.13135 25.2 7.8 25.2Z" />
            <path
              d="M7.8 27.6H3C2.66865 27.6 2.4 27.8687 2.4 28.2C2.4 28.5314 2.66865 28.8 3 28.8H7.8C8.13135 28.8 8.4 28.5314 8.4 28.2C8.4 27.8687 8.13135 27.6 7.8 27.6Z" />
            <path
              d="M7.8 30H3C2.66865 30 2.4 30.2687 2.4 30.6C2.4 30.9314 2.66865 31.2 3 31.2H7.8C8.13135 31.2 8.4 30.9314 8.4 30.6C8.4 30.2687 8.13135 30 7.8 30Z" />
            <path
              d="M7.8 32.4H3C2.66865 32.4 2.4 32.6687 2.4 33C2.4 33.3314 2.66865 33.6 3 33.6H7.8C8.13135 33.6 8.4 33.3314 8.4 33C8.4 32.6687 8.13135 32.4 7.8 32.4Z" />
            <path
              d="M20.4 22.8H15.6C15.2687 22.8 15 23.0687 15 23.4C15 23.7314 15.2687 24 15.6 24H20.4C20.7313 24 21 23.7314 21 23.4C21 23.0687 20.7313 22.8 20.4 22.8Z" />
            <path
              d="M20.4 25.2H15.6C15.2687 25.2 15 25.4687 15 25.8C15 26.1314 15.2687 26.4 15.6 26.4H20.4C20.7313 26.4 21 26.1314 21 25.8C21 25.4687 20.7313 25.2 20.4 25.2Z" />
            <path
              d="M20.4 27.6H15.6C15.2687 27.6 15 27.8687 15 28.2C15 28.5314 15.2687 28.8 15.6 28.8H20.4C20.7313 28.8 21 28.5314 21 28.2C21 27.8687 20.7313 27.6 20.4 27.6Z" />
            <path
              d="M20.4 30H15.6C15.2687 30 15 30.2687 15 30.6C15 30.9314 15.2687 31.2 15.6 31.2H20.4C20.7313 31.2 21 30.9314 21 30.6C21 30.2687 20.7313 30 20.4 30Z" />
            <path
              d="M20.4 32.4H15.6C15.2687 32.4 15 32.6687 15 33C15 33.3314 15.2687 33.6 15.6 33.6H20.4C20.7313 33.6 21 33.3314 21 33C21 32.6687 20.7313 32.4 20.4 32.4Z" />
            <path
              d="M33 22.8H28.8C28.4687 22.8 28.2 23.0687 28.2 23.4C28.2 23.7314 28.4687 24 28.8 24H33C33.3314 24 33.6 23.7314 33.6 23.4C33.6 23.0687 33.3314 22.8 33 22.8Z" />
            <path
              d="M33 25.2H28.8C28.4687 25.2 28.2 25.4687 28.2 25.8C28.2 26.1314 28.4687 26.4 28.8 26.4H33C33.3314 26.4 33.6 26.1314 33.6 25.8C33.6 25.4687 33.3314 25.2 33 25.2Z" />
            <path
              d="M33 27.6H28.8C28.4687 27.6 28.2 27.8687 28.2 28.2C28.2 28.5314 28.4687 28.8 28.8 28.8H33C33.3314 28.8 33.6 28.5314 33.6 28.2C33.6 27.8687 33.3314 27.6 33 27.6Z" />
            <path
              d="M33 30H28.8C28.4687 30 28.2 30.2687 28.2 30.6C28.2 30.9314 28.4687 31.2 28.8 31.2H33C33.3314 31.2 33.6 30.9314 33.6 30.6C33.6 30.2687 33.3314 30 33 30Z" />
            <path
              d="M33 32.4H28.8C28.4687 32.4 28.2 32.6687 28.2 33C28.2 33.3314 28.4687 33.6 28.8 33.6H33C33.3314 33.6 33.6 33.3314 33.6 33C33.6 32.6687 33.3314 32.4 33 32.4Z" />
            <path
              d="M33 10.8H28.8C28.4687 10.8 28.2 11.0687 28.2 11.4C28.2 11.7314 28.4687 12 28.8 12H33C33.3314 12 33.6 11.7314 33.6 11.4C33.6 11.0687 33.3314 10.8 33 10.8Z" />
            <path
              d="M33 13.2H28.8C28.4687 13.2 28.2 13.4687 28.2 13.8C28.2 14.1314 28.4687 14.4 28.8 14.4H33C33.3314 14.4 33.6 14.1314 33.6 13.8C33.6 13.4687 33.3314 13.2 33 13.2Z" />
            <path
              d="M33 15.6H28.8C28.4687 15.6 28.2 15.8687 28.2 16.2C28.2 16.5314 28.4687 16.8 28.8 16.8H33C33.3314 16.8 33.6 16.5314 33.6 16.2C33.6 15.8687 33.3314 15.6 33 15.6Z" />
            <path
              d="M33 18H28.8C28.4687 18 28.2 18.2687 28.2 18.6C28.2 18.9314 28.4687 19.2 28.8 19.2H33C33.3314 19.2 33.6 18.9314 33.6 18.6C33.6 18.2687 33.3314 18 33 18Z" />
            <path
              d="M33 20.4H28.8C28.4687 20.4 28.2 20.6687 28.2 21C28.2 21.3314 28.4687 21.6 28.8 21.6H33C33.3314 21.6 33.6 21.3314 33.6 21C33.6 20.6687 33.3314 20.4 33 20.4Z" />
            <path
              d="M33 8.4H28.8C28.4687 8.4 28.2 8.66865 28.2 9C28.2 9.33135 28.4687 9.6 28.8 9.6H33C33.3314 9.6 33.6 9.33135 33.6 9C33.6 8.66865 33.3314 8.4 33 8.4Z" />
          </svg>
        </div>
        <div class="car-sell-offer__feature-title">Multidimensional Analysis</div>
        <div class="car-sell-offer__feature-desc">Detailed insights on performance and safety.</div>
      </div>

      <div class="car-sell-offer__feature">
        <div class="car-sell-offer__icon-wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" class="car-sell-offer__feature-icon" width="32"
            height="36" viewBox="0 0 32 36" fill="none">
            <path
              d="M30.9647 32.5722C26.0586 30.2567 22.0134 26.4539 19.408 21.708L19.5682 21.5484L20.6477 22.6242C21.5417 23.5212 22.9961 23.5261 23.8962 22.6353C24.3619 22.1744 24.6074 21.5372 24.571 20.8842C24.6095 20.8842 24.6475 20.8956 24.686 20.8956C25.9496 20.9007 26.9781 19.884 26.9832 18.6248C26.9834 18.5779 26.9821 18.5311 26.9794 18.4842C27.0179 18.4842 27.0559 18.4956 27.0944 18.4956C28.358 18.5007 29.3865 17.484 29.3916 16.2248C29.3918 16.1779 29.3905 16.1311 29.3878 16.0842C29.4263 16.0842 29.4643 16.0956 29.5028 16.0956C30.7754 16.0962 31.8075 15.0686 31.8081 13.8005C31.8084 13.1909 31.5654 12.6061 31.1327 12.1752L30.0531 11.1L31.1327 10.0242C31.3677 9.7899 31.3677 9.4101 31.1327 9.1758L30.3542 8.4L31.7348 7.0242C31.9698 6.7899 31.9698 6.4101 31.7348 6.1758L29.3264 3.7758C29.1763 3.6297 28.96 3.57338 28.7574 3.6276C29.743 3.3477 30.3144 2.32463 30.0335 1.34243C29.8063 0.547875 29.0777 -7.49923e-05 28.2486 7.69821e-09H20.4713C20.3116 7.69821e-09 20.1585 0.0633 20.0456 0.1758L17.8137 2.4H0.602098C0.269589 2.4 0 2.66865 0 3V10.8C0 11.1314 0.269589 11.4 0.602098 11.4H9.89488L11.526 14.109C11.5514 14.1509 11.5817 14.1896 11.6163 14.2242L13.599 16.2L9.25003 20.5338C4.53621 23.6813 1.28608 28.5812 0.227593 34.1364L0.0108378 35.289C-0.0506514 35.6147 0.164373 35.9284 0.491161 35.9897C0.527739 35.9965 0.564843 36 0.602098 36H30.194C31.1916 35.9999 32.0001 35.1938 32 34.1997C31.9999 33.5033 31.5967 32.8694 30.9647 32.5722ZM23.0561 21.7758V21.78C22.6259 22.2077 21.9294 22.2077 21.4991 21.78L19.0907 19.38C18.67 18.9423 18.685 18.2477 19.1242 17.8284C19.5501 17.4218 20.2218 17.4218 20.6477 17.8284L23.0561 20.2284C23.4825 20.6567 23.4825 21.3475 23.0561 21.7758ZM25.4645 19.3758V19.38C25.0343 19.8076 24.3378 19.8076 23.9075 19.38L21.4991 16.98C21.0784 16.5423 21.0934 15.8477 21.5326 15.4284C21.9585 15.0218 22.6302 15.0218 23.0561 15.4284L25.4645 17.8284C25.8909 18.2567 25.8909 18.9475 25.4645 19.3758ZM27.8729 16.9758V16.98C27.4426 17.4076 26.7462 17.4076 26.3159 16.98L23.9075 14.58C23.4868 14.1423 23.5018 13.4477 23.941 13.0284C24.3669 12.6218 25.0386 12.6218 25.4645 13.0284L27.8729 15.4284C28.2993 15.8567 28.2993 16.5475 27.8729 16.9758ZM30.2813 13.0284C30.7077 13.4567 30.7077 14.1475 30.2813 14.5758V14.58C29.851 15.0077 29.1546 15.0077 28.7243 14.58L26.3159 12.18C25.8952 11.7423 25.9102 11.0477 26.3494 10.6284C26.7753 10.2218 27.447 10.2218 27.8729 10.6284L30.2813 13.0284ZM28.9007 5.0484L30.4577 6.6L29.5028 7.5516L27.9458 6L28.9007 5.0484ZM27.0944 5.1516L26.3159 4.3758C26.0808 4.14158 25.6996 4.14158 25.4645 4.3758L24.686 5.1516L23.6209 4.0902L28.4028 3.6936C28.494 3.684 28.5844 3.6675 28.6731 3.6444C28.599 3.67478 28.5317 3.7194 28.475 3.7758L27.0944 5.1516ZM12.52 13.428L10.7517 10.491C10.6428 10.3105 10.447 10.2001 10.2357 10.2H1.2042V3.6H18.0629C18.2226 3.6 18.3757 3.5367 18.4886 3.4242L20.7206 1.2H28.2468C28.607 1.19662 28.9016 1.48485 28.9049 1.84373C28.9082 2.18633 28.6438 2.47253 28.301 2.4978L22.2276 3C21.8963 3.02865 21.6511 3.3195 21.6799 3.64965C21.6921 3.78938 21.753 3.9204 21.8519 4.02L23.8346 6L14.4503 15.3516L12.52 13.428ZM25.1105 6.4296L25.8902 5.6484L29.8556 9.6L29.2017 10.2516L28.7243 9.78C27.8303 8.883 26.376 8.87805 25.4759 9.7689C25.0102 10.2298 24.7647 10.8671 24.8011 11.52C23.5446 11.4466 22.4664 12.4022 22.3927 13.6542C22.3875 13.7427 22.3875 13.8315 22.3927 13.92C21.1362 13.8466 20.058 14.8022 19.9843 16.0542C19.9791 16.1427 19.9791 16.2315 19.9843 16.32C18.7176 16.2499 17.6338 17.2163 17.5634 18.4784C17.527 19.1314 17.7726 19.7687 18.2382 20.2296L18.7157 20.7054L18.4315 20.9886L10.9962 20.4948L25.1105 6.4296ZM30.7324 34.4615C30.6323 34.6674 30.4235 34.7987 30.194 34.8H1.32763L1.41072 34.3578C2.40463 29.1691 5.42392 24.5853 9.80577 21.6126L18.2953 22.1766C21.0192 27.1954 25.278 31.2181 30.4529 33.66C30.7522 33.8045 30.8773 34.1632 30.7324 34.4615Z" />
          </svg>
        </div>
        <div class="car-sell-offer__feature-title">Comprehensive Ratings</div>
        <div class="car-sell-offer__feature-desc">Expert and user-based scores.</div>
      </div>

      <div class="car-sell-offer__feature">
        <div class="car-sell-offer__icon-wrapper">
          <svg class="car-sell-offer__feature-icon" xmlns="http://www.w3.org/2000/svg" width="32"
            height="44" viewBox="0 0 32 44" fill="none">
            <path
              d="M27.5636 9.89197C27.6105 9.52988 27.6348 9.16523 27.6364 8.80003C27.6364 3.93994 23.729 0 18.9091 0C14.0892 0 10.1818 3.93994 10.1818 8.80003C10.1818 9.0479 10.1964 9.2921 10.216 9.53337H10.1818C7.31073 9.53823 4.87173 11.6526 4.43636 14.5142C1.74891 15.6649 0.00272727 18.3227 0 21.2667V35.2001C0.00236364 37.2241 1.62909 38.8644 3.63636 38.8668H10.9091C12.9164 38.8644 14.5431 37.2241 14.5455 35.2001V21.2667C14.5436 20.675 14.4704 20.0857 14.3273 19.5119C15.0096 18.8166 15.5072 17.959 15.7738 17.0185C16.3177 17.2257 16.8807 17.3778 17.4545 17.4725V21.2667C17.4569 23.2908 19.0836 24.931 21.0909 24.9334H21.8182V41.0668C21.8182 41.2613 21.8949 41.4478 22.0313 41.5853L24.2131 43.7853C24.4971 44.0716 24.9575 44.0716 25.2415 43.7853L27.4233 41.5853C27.5596 41.4478 27.6364 41.2613 27.6364 41.0668V38.1335C27.6364 37.939 27.5596 37.7525 27.4233 37.615L26.4829 36.6668L27.4233 35.7186C27.5596 35.5811 27.6364 35.3946 27.6364 35.2001V34.4668C27.6364 34.2723 27.5596 34.0858 27.4233 33.9483L26.4829 33.0001L27.4233 32.0519C27.5596 31.9144 27.6364 31.728 27.6364 31.5334V30.8001C27.6364 30.6056 27.5596 30.4191 27.4233 30.2816L26.4829 29.3334L27.4233 28.3852C27.5596 28.2477 27.6364 28.0613 27.6364 27.8668V24.9334H28.3636C30.3709 24.931 31.9976 23.2908 32 21.2667V16.1334C31.9955 13.3109 30.2129 10.8031 27.5636 9.89197ZM5.09091 20.1667C5.09209 19.7163 5.25927 19.2824 5.56 18.9494C6.04909 19.5978 6.66591 20.137 7.37164 20.5334H5.09091V20.1667ZM6.94182 18.3371V18.3334C7.67464 18.3477 8.32718 18.8042 8.59709 19.4913C7.96382 19.2416 7.39709 18.8464 6.94182 18.3371ZM13.0909 35.2001C13.0909 36.4152 12.1141 37.4001 10.9091 37.4001H3.63636C2.43136 37.4001 1.45455 36.4152 1.45455 35.2001V21.2667C1.45664 19.1502 2.58918 17.1989 4.41818 16.1605C4.48282 16.6739 4.61509 17.1763 4.81164 17.6543C4.07045 18.2751 3.64009 19.1952 3.63636 20.1667V21.2667C3.63636 21.6717 3.962 22.0001 4.36364 22.0001H9.45455C9.85618 22.0001 10.1818 21.6717 10.1818 21.2667V19.8001C10.1695 19.8001 10.1571 19.8001 10.1447 19.8001C9.97409 18.0174 8.40254 16.7117 6.63464 16.8839C6.45836 16.901 6.28382 16.9328 6.11273 16.9789C5.94364 16.5356 5.84736 16.0675 5.82764 15.5929C8.92364 14.7752 12.0908 16.643 12.9018 19.7648C13.0292 20.255 13.0927 20.7599 13.0909 21.2667V35.2001ZM14.4356 16.3659C14.3114 16.9307 14.0767 17.4649 13.7455 17.9374C12.313 15.061 9.17336 13.4789 6.032 14.0507C6.61391 12.2348 8.28927 11.0032 10.1818 11C10.2771 11 10.3709 11.0081 10.4647 11.0147C11.0314 13.2596 12.4606 15.185 14.4371 16.3659H14.4356ZM12.1251 11.4672C13.3585 12.0885 14.2286 13.2604 14.4727 14.6286C13.4161 13.8131 12.6036 12.7191 12.1251 11.4672ZM17.4618 15.9867C16.9576 15.8847 16.4656 15.7289 15.9942 15.5218C15.9942 15.4815 16 15.4419 16 15.4015C15.9954 12.755 14.2355 10.4388 11.7025 9.7453C11.6605 9.43198 11.6385 9.11619 11.6364 8.80003C11.6364 4.74991 14.8925 1.46667 18.9091 1.46667C22.9257 1.46667 26.1818 4.74991 26.1818 8.80003C26.177 9.05679 26.1585 9.31309 26.1265 9.56783C25.9033 9.54483 25.679 9.53337 25.4545 9.53337H24C20.445 9.53914 17.5435 12.4031 17.4618 15.9867ZM26.9091 14.6667C26.9091 15.0717 26.5835 15.4001 26.1818 15.4001H24.6778C25.167 14.9619 25.6061 14.4699 25.9869 13.9334H26.1818C26.5835 13.9334 26.9091 14.2617 26.9091 14.6667ZM26.1818 27.5632L24.9404 28.815C24.6565 29.1013 24.6565 29.5655 24.9404 29.8519L26.1818 31.1037V31.2298L24.9404 32.4817C24.6565 32.768 24.6565 33.2322 24.9404 33.5186L26.1818 34.7704V34.8965L24.9404 36.1483C24.6565 36.4347 24.6565 36.8989 24.9404 37.1853L26.1818 38.4371V40.7632L24.7273 42.2299L23.2727 40.7632V24.9334H26.1818V27.5632ZM30.5455 21.2667C30.5455 22.4818 29.5686 23.4668 28.3636 23.4668H21.0909C19.8859 23.4668 18.9091 22.4818 18.9091 21.2667V16.1334C18.9123 13.2997 21.1897 11.0032 24 11H25.4545C25.5811 11 25.7055 11.0103 25.8291 11.0191C25.6671 11.5237 25.4513 12.009 25.1855 12.4667H23.2727C22.0702 12.4672 21.0956 13.4506 21.0962 14.6632C21.0965 15.5802 21.662 16.4003 22.5142 16.7201L22.5498 16.7985C22.5775 16.7853 22.6036 16.7699 22.6313 16.7567C22.8383 16.8263 23.0545 16.8634 23.2727 16.8667H26.1818C27.3835 16.8698 28.3603 15.8899 28.3633 14.6781C28.3657 13.6983 27.7235 12.8356 26.7898 12.5642C26.977 12.1687 27.1345 11.7596 27.2611 11.3403C29.2353 12.0972 30.5416 14.0037 30.5455 16.1334V21.2667ZM24.0727 13.9334C23.6542 14.3659 23.1839 14.7443 22.6727 15.0598C22.5926 14.9444 22.5484 14.8075 22.5455 14.6667C22.5455 14.2617 22.8711 13.9334 23.2727 13.9334H24.0727Z" />
            <path
              d="M9.45455 23.4668H5.09091C3.88591 23.4668 2.90909 24.4517 2.90909 25.6668V33.7335C2.90909 34.9485 3.88591 35.9335 5.09091 35.9335H9.45455C10.6595 35.9335 11.6364 34.9485 11.6364 33.7335V25.6668C11.6364 24.4517 10.6595 23.4668 9.45455 23.4668ZM10.1818 33.7335C10.1818 34.1384 9.85618 34.4668 9.45455 34.4668H5.09091C4.68927 34.4668 4.36364 34.1384 4.36364 33.7335V32.2668H10.1818V33.7335ZM10.1818 30.8001H4.36364V28.6001H10.1818V30.8001ZM10.1818 27.1334H4.36364V25.6668C4.36364 25.2618 4.68927 24.9334 5.09091 24.9334H9.45455C9.85618 24.9334 10.1818 25.2618 10.1818 25.6668V27.1334Z" />
          </svg>
        </div>
        <div class="car-sell-offer__feature-title">Latest Vehicle Info</div>
        <div class="car-sell-offer__feature-desc">Up-to-date market releases.</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CarSellOffer',
  computed: {
    ...mapGetters({
      deviceType: 'deviceType',
      domainConfig: 'domainConfig'
    })
  },
  methods: {
    // 跳转到全部车辆页面
    gotoAll () {
      // 获取当前路由的channel参数
      const currentChannel = this.$router.currentRoute.params.channel;

      // 如果存在channel参数，则构建带channel的路径
      if (currentChannel) {
        // 构建完整URL
        const baseUrl = window.location.origin;
        // 直接获取当前URL的查询字符串，包括?前缀
        const fullQueryString = window.location.search;
        const fullPath = `${baseUrl}/${currentChannel}/car-list${fullQueryString}`;

        // 使用location跳转
        window.location.href = fullPath;
      } else {
        // 没有channel参数，使用常规router跳转
        this.$router.push({
          path: '/car-list'
        });
      }
    }
  }
}
</script>

<style lang="scss" >
@import '~@/css/variables.scss';

.car-sell-offer {
	padding: rem(60) 0 rem(210);
	background: #ffffff;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
	position: relative;

	&__container {
		padding: 0 rem(120);
		width: 100%;
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: space-between;
		// margin-bottom: rem(40);
		box-sizing: border-box;
	}

	&__info {
		width: rem(500);
		display: flex;
		flex-direction: column;
		gap: rem(20);
		z-index: 2;
	}

	&__title {
		color: #141414;
		font-size: rem(24);
		line-height: rem(32);
		font-weight: 700;
	}

	&__desc {
		color: #555555;
		font-size: rem(14);
		line-height: rem(16);
		margin-bottom: rem(20);
	}

	&__button {
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: rem(10);
		background: var(--theme-color);
		text-align: center;
		border-radius: rem(8);
		padding: rem(14) rem(40);
		width: rem(220);
		cursor: pointer;
		transition: all 0.3s ease;
		display: flex;
		justify-content: center;

		&:hover {
			opacity: 0.7;
		}
	}

	&__button-text {
		color: #ffffff;
		font-size: rem(16);
		font-weight: 600;
	}

	&__icon {
		width: rem(16);
		height: rem(16);
	}

	&__gallery {
		flex: 1;
		height: rem(380);
		max-width: rem(600);
		border-radius: rem(24) rem(24) 0 0;
		overflow: hidden;
		border-bottom: 4px solid var(--theme-color);
	}

	&__gallery-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		object-position: center;
	}

	&__features {
		padding: 0 rem(120);
		width: 100%;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		gap: rem(20);
		box-sizing: border-box;
		position: absolute;
		top: rem(324);
	}

	&__feature {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: flex-start;
		// gap: rem(20);
		background: #141414 url('~@/assets/offer-texture.png');
		border-radius: rem(24);
		padding: rem(24);
		transition: all 0.3s ease;
		color: #ffffff;
		width: rem(220);
		min-height: rem(220);

		&:hover {
			transform: translateY(-4px);
		}
	}

	&__icon-wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		width: rem(68);
		height: rem(68);
		border-radius: rem(16);
		border: 1px solid var(--theme-color);
		background: #141414;
		margin-bottom: rem(20);
	}

	&__feature-icon {
		width: rem(36);
		height: rem(36);
		path {
			fill: var(--theme-color);
		}
	}

	&__feature-title {
		font-size: rem(18);
		line-height: rem(20);
		font-weight: 700;
	}

	&__feature-desc {
		font-size: rem(14);
		line-height: rem(18);
		font-weight: 400;
		opacity: 0.8;
	}
}

// 响应式样式 - PC设备
.detect_deviece_pc,
.detect_deviece_desktop {
	.car-sell-offer {
		--fontsize-base: #{$vw_fontsize_pc};
		font-size: calc(var(--fontsize-base) / #{$vw_design_pc} * 100vw);
	}
}

// 响应式样式 - 移动设备
.detect_deviece_mobile {
	.car-sell-offer {
		--fontsize-base: #{$vw_fontsize_mobile};
		font-size: calc(var(--fontsize-base) / #{$vw_design_mobile} * 100vw);
		padding: rem(60) 0;
		gap: rem(32);

		&__container {
			padding: 0 rem(16);
			flex-direction: column;
			gap: rem(32);
		}

		&__info {
			width: 100%;
			order: 2;
			gap: rem(16);
		}

		&__title {
			font-size: rem(24);
			line-height: rem(30);
		}

		&__desc {
			font-size: rem(14);
			line-height: rem(20);
			margin-bottom: rem(16);
		}

		&__button {
			width: rem(220);
		}

		&__gallery {
			width: 100%;
			height: rem(230);
			max-width: none;
			order: 1;
		}

		&__features {
			padding: 0 rem(16);
			flex-direction: column;
			gap: rem(16);
			position: relative;
			top: 0;
		}

		&__feature {
			width: 100%;
			height: fit-content;
		}
	}
}
</style> 